
import { environment } from './environment';

export default class ApiService
{
    constructor ( $http, $q, $cookies )
    {
        'ngInject';

        Object.assign( this, { $http, $q, $cookies } );

        this.data = {};
    }

    get token ()
    {
        if ( !this.userData ) return null;

        return this.userData.token;
    }
    get userData ()
    {
        let dataOut = this.$cookies.get( environment.userData );

        if ( !dataOut ) return null;

        let userData = JSON.parse( dataOut );
        return userData;
    }

    get ( params )
    {
        return this.$http.get( params.url,
            {
                headers: {
                    'Authorization': `Bearer ${ this.token }`
                },
                ...params.config
            } )
            .then( response =>
            {
                this.storeData( params.name, response.data );

                if ( response && response.data && response.data.value )
                    return response.data.value;

                return response.data;
            } )
            .catch( error =>
            {
                if ( error.status == 401 )
                    this.clearUserData();

                console.log( error )
                error
            } );
    }

    put ( params )
    {
        return this.$http.put( params.url, params.data,
            {
                headers: {
                    'Authorization': `Bearer ${ this.token }`
                },
                ...params.config
            } )
            .then( response =>
            {
                this.storeData( params.name, response.data );
                return response.data;
            } )
            .catch( error =>
            {
                if ( error.status == 401 )
                    this.clearUserData();

                console.log( error )
                error
            } );
    }

    patch ( params )
    {
        return this.$http.patch( params.url, params.data,
            {
                headers: {
                    'Authorization': `Bearer ${ this.token }`
                },
                ...params.config
            } )
            .then( response =>
            {
                this.storeData( params.name, response.data );
                return response.data;
            } )
            .catch( error =>
            {
                if ( error.status == 401 )
                    this.clearUserData();

                console.log( error )
                error
            } );
    }

    post ( params )
    {
        return this.$http.post( params.url, params.data,
            {
                headers: {
                    'Authorization': `Bearer ${ this.token }`
                },
                ...params.config
            } )
            .then( response =>
            {
                this.storeData( params.name, response.data );
                return response.data;
            } )

            .catch( error =>
            {
                if ( error.status == 401 )
                    this.clearUserData();

                console.log( error )
                error
            } );
    }

    storeData ( k, v )
    {
        this.data[ k ] = v;
    }

    getData ()
    {
        return this.data;
    }

    clearUserData ()
    {
        this.$cookies.remove( environment.userData );
    }
}



// WEBPACK FOOTER //
// ./client/app/services/api.service.js